<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='住宿管理' label2="修改住宿登记" url="/cycle/stay/list"></PageHead>
      <el-form class="m-form m-form--fit m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <!--begin: Form Body -->
          <div class="form-group m-form__group row">
            <label class="col-xl-4 col-form-label m--align-right">住培生姓名：</label>
            <div class="col-xl-6" style="padding-top:8px">
              <span>{{form.stuname}}</span>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-4 col-form-label m--align-right">住培生工号：</label>
            <div class="col-xl-6" style="padding-top:8px">
              <span>{{form.stuno}}</span>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-4 col-form-label m--align-right">住宿时间：</label>
            <div class="col-xl-6 input-group">
              <el-form-item prop="stulivebegindate" :rules="{required: true, message: '开始月份不能为空', trigger: 'blur'}">
                <el-date-picker v-model="form.stulivebegindate" type="month" placeholder="开始月份" value-format="yyyy-MM" @change="LoadRoom">
                </el-date-picker>
              </el-form-item>
              <span style="padding:10px">至</span>
              <el-form-item prop="stuliveenddate" :rules="{required: true, message: '结束月份不能为空', trigger: 'blur'}">
                <el-date-picker v-model="form.stuliveenddate" type="month" placeholder="结束月份" value-format="yyyy-MM">
                </el-date-picker>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-4 col-form-label m--align-right">房间：</label>
            <div class="col-xl-2">
              <el-form-item prop="room" :rules="{required: true, message: '房间不能为空', trigger: 'blur'}">
                <el-select v-model="form.room" filterable placeholder="请选择">
                  <el-option label="请选择" value=""></el-option>
                  <el-option v-for="item in roomOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
            <div class="m-form__actions m-form__actions--solid">
              <div class="row">
                <div class="col-lg-12 m--align-center">
                  <SaveButton :url='saveUrl' back="/cycle/stay/list"></SaveButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StayEdit',
    data() {
      return {
        form: {
          id: '',
          stuname: '',
          stuno: '',
          stulivebegindate: '',
          stuliveenddate: '',
          token: '',
          room: ''
        },
        roomOptions: [],
        saveUrl: this.$utils.Url.zpgl + '/api/APIRoom/RoomRecordUpdate'
      }
    },
    methods: {
      LoadRoom: function() {
        var args = {
          token: this.form.token,
          month: this.form.stulivebegindate,
          id: this.form.id
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIRoom/EditList', args, function(data) {
          that.roomOptions = []
          for (var i = 0; i < data.Data.length; i++) {
            var peoplenum = data.Data[i]["PeopleNum"] / 1
            var staycount = data.Data[i]["StayCount"] / 1
            var num = peoplenum - staycount
            if(num < 0){
              num = 0
            }
            var label = data.Data[i]["RoomName"] + '(尚可入住' + num + '人)'
            var arg = {
              value: data.Data[i]["ID"],
              label: label
            }
            that.roomOptions.push(arg)
          }
        }, null, null, null)
      },
      LoadRoomRecord: function() {
        var args = {
          id: this.form.id,
          token: this.form.token
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIRoom/RoomRecordViewInfo', args, function(data, model) {
          model.stuname = data.Data.StuName
          model.stuno = data.Data.StuNo
          var startdate = new Date(data.Data.StartDate)
          var syear = startdate.getFullYear()
          var smonth = startdate.getMonth() + 1
          model.stulivebegindate = syear + '-' + smonth
          var enddate = new Date(data.Data.EndDate)
          var eyear = enddate.getFullYear()
          var emonth = enddate.getMonth() + 1
          model.stuliveenddate = eyear + '-' + emonth
          model.room = data.Data.RoomID
          that.LoadRoom()
        }, null, null, this.form)
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.form.id = this.$route.params.id
      this.LoadRoomRecord()
    }
  }
</script>

<style>
</style>
